<template>
    <!-- Wallboard.vue -->
    <v-container class="py-0" fluid data-test="wallboardContainer">
        <v-row>
            <!-- Stats Container -->
            <v-col class="py-0" cols="12" lg="9" md="8">
                <stats-container
                    :items="wallboardCards"
                    :loading="wallboardLoading"
                    :title="wallboardName"
                ></stats-container>
            </v-col>
            <!-- Agents Container -->
            <v-col class="py-0" cols="12" lg="3" md="4">
                <agents-container
                    :items="agentsFiltered"
                    :loading="agentsLoading"
                ></agents-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AgentsContainer from '@/components/AgentsContainer'
    import StatsContainer from '@/components/StatsContainer'

    export default {
        name: 'Wallboard',
        metaInfo () {
            const vm = this
            return {
                title: vm.loading ? 'Loading...' : vm.wallboardName
            }
        },
        props: {
            /**
             * The contact centre uuid
             */
            wallboardUuid: {
                type: String,
                default: ''
            },
            /**
             * The auth token for the wallboard
             */
            token: {
                type: String,
                default: ''
            }
        },
        components: {
            AgentsContainer,
            StatsContainer
        },
        computed: {
            ...mapGetters('wallboard', ['wallboardCards', 'wallboardLoading', 'wallboardName']),
            ...mapGetters('wallboard/agents', ['agentsFiltered', 'agentsLoading'])
        }
    }
</script>
